export default __webpack_public_path__ + "static/media/feedback.e6775efd.png";